const ItemGenerator = require('../../../game_items/ItemGenerator');
const Hammer = require('../../../game_items/equipment/weapon/Hammer');
const getMobEquipmenAssignmentFromBags = require('../mobs/getMobEquipmenAssignmentFromBags');

const goo = (level) => {
  const handle = 'goo';
  const types = ['amorphous', 'jelly'];
  const AI_PRIORITIES = ['support', 'dps_close', 'tank', 'interference', 'dps_ranged'];
  const equipped_abilities = [
    { value: 'move' },
    { value: 'melee_attack' },
    { value: 'poison_weapon' },
  ];
  const bags = [
    {
      value: {
        items: [{ value: ItemGenerator.getCavernsMobItem(Hammer, level) }],
      },
    },
  ];

  return {
    handle,
    types,
    level,
    getAbilityTrees: ((bound_level) => [
      {
        handle: 'goo_abilities',
        abilities: {
          move: { handle: 'move', level: 1 },
          melee_attack: { handle: 'melee_attack', level: 1 },
          poison_weapon: {
            handle: 'poison_weapon',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
        },
      },
    ]).bind(null, level),
    getBaseAttributes: ((bound_level) => ({
      learning: Math.round(1 + bound_level * 0.3 + Math.random() * 3),
      perception: Math.round(1 + bound_level * 0.3 + Math.random() * 3),
      mana: Math.round(1 + bound_level * 0.3 + Math.random() * 3),
      toughness: Math.round(3 + bound_level * 0.8 + Math.random() * 3),
      strength: Math.round(2 + bound_level * 0.55 + Math.random() * 3),
      willpower: Math.round(2 + bound_level * 0.55 + Math.random() * 3),
      dexterity: Math.round(1 + bound_level * 0.3 + Math.random() * 3),
    })).bind(null, level),
    getDefaultAIConfig: () => AI_PRIORITIES,
    xpValue: level * 28,
    drops_gold: false,
    drops_equipment: false,
    bags,
    build: {
      ai: {
        priorities: AI_PRIORITIES,
        settings: {
          chanceToSkipRoles: true,
          autoMove: true,
          waitForAPMP: false,
        },
      },
      ai_unit: true,
      equipment_assignment: getMobEquipmenAssignmentFromBags(bags),
      equipped_abilities,
      handle,
      level,
      team: 'black',
      types,
      unit: true,
    },
  };
};
module.exports = goo;
